import Icon from '@components/icons';
import { Accordion } from '@screens/landing-page-tools/types';
import AccordionCard from '@screens/lp-default/components/tools/components/accordion-card';
import * as Styles from '@screens/lp-default/components/tools/components/tab-accordion-item/styles';
import { useState } from 'react';
import { FadeOverlay } from '@screens/landing-page-tools/styles';
import { snowplowButtonClick } from '@analytics/snowplow/events';

type props = {
  tab: string;
  accordion: Accordion;
  onClick(): void;
};

export default function TabAccordionItem({ tab, accordion, onClick }: props) {
  const [expandedCardId, setExpandedCardId] = useState(accordion.cards[0].id);

  const handleExpand = (title: string, cardId: number) => {
    snowplowButtonClick('collapse', '/planos', title, tab);
    setExpandedCardId(cardId);
  };

  return (
    <Styles.AccordionItem key={accordion.title} value={accordion.title} data-testid="accordion-item">
      <Styles.AccordionTrigger onClick={onClick}>
        <Styles.AccordionTitle>{accordion.title}</Styles.AccordionTitle>
        <Styles.AccordionButton>
          <Icon icon="caret-down" size={17} />
        </Styles.AccordionButton>
      </Styles.AccordionTrigger>
      <Styles.AccordionContent>
        <FadeOverlay />
        <Styles.TabSubtitle>Ferramentas de apoio</Styles.TabSubtitle>
        <Styles.DetailsWrapper>
          {accordion.cards.map((card) => (
            <AccordionCard key={card.id} card={card} isExpanded={card.id === expandedCardId} onExpand={handleExpand} />
          ))}
        </Styles.DetailsWrapper>
      </Styles.AccordionContent>
    </Styles.AccordionItem>
  );
}
